import { render } from "./SudaniPlans.vue?vue&type=template&id=4fdbbef0&scoped=true"
import script from "./SudaniPlans.vue?vue&type=script&lang=js"
export * from "./SudaniPlans.vue?vue&type=script&lang=js"

import "./SudaniPlans.vue?vue&type=style&index=0&id=4fdbbef0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fdbbef0"]])

export default __exports__